//Types file for declaring all the types used by the reducer
const PREVIEW_TEMPLATE = "PREVIEW";
const SET_USER = "SET_USER";
const REMOVE_USER = "REMOVE_USER";
export default { PREVIEW_TEMPLATE, SET_USER, REMOVE_USER };

